import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-quill/dist/quill.snow.css';
import 'nprogress/nprogress.css';
import 'src/assets/css/prism.css';
import 'src/assets/css/index.scss';
import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as serviceWorker from 'src/serviceWorker';
import { SettingsProvider } from 'src/context/SettingsContext';
import { configureStore } from 'src/store';
import { restoreSettings } from 'src/utils/settings';
import './i18n/i18n';
import App from 'src/App';
import { BrowserRouter } from 'react-router-dom';
import { enablePatches } from 'immer';
import ProductProvider from './context/ProductContext';
import TopMenuOptionProvider from './context/TopMenuOptionContext';

enablePatches();

const store = configureStore;
const settings = restoreSettings();
const root = createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <SettingsProvider settings={settings}>
      <ProductProvider>
        <TopMenuOptionProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </TopMenuOptionProvider>
      </ProductProvider>
    </SettingsProvider>
  </Provider>
);

serviceWorker.unregister();

// eslint-disable-next-line no-extend-native, func-names
Date.prototype.yyyymmdd = function () {
  const mm = this.getMonth() + 1; // getMonth() is zero-based
  const dd = this.getDate();

  return [
    this.getFullYear(),
    (mm > 9 ? '' : '0') + mm,
    (dd > 9 ? '' : '0') + dd
  ].join('-');
};
